import React from "react";
import { Link } from "react-router-dom";
import ChatButton from "../../components/ChatButton";
import { Helmet } from "react-helmet";

const Travel = () => {
  return (
    <>
    <Helmet>
      <title>Travel loan - Best personal loan for Holiday | CreduMoney</title>
      <meta name="title" content="Travel loan - Best personal loan for Holiday | CreduMoney"/>
      
    </Helmet>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
           <div className="service_page_banner_wrapper_overlay">
            <h2>Travel</h2>
          </div>
        </div>

        <div className="text_content_wrapper">
          <div className="text_content">
            {/* <div className="content_banner">
                <img src={specific_location_img} alt="" />
              </div> */}
            <h1 className="page_title mt30 mb20">Travel Now, Pay Later with CreduMoney’s Instant Personal Loan for Travel</h1>
            

            <p>Who doesn’t want to go to the Maldives, Bali, Thailand, Goa, Himachal, Kashmir? These breathtaking tourist destinations are a picture to the eyes and a melodious music to the ears. Lush greenery, towering mountains, pristine rivers, sun-kissed beaches, local cuisines, etc—you get to witness these all when you travel.</p>

        
            <p>However, we all know travel plans are frequently cancelled or delayed, mainly due to a shortage of funds. But not now because CreduMoney, the best RBI-registered NBFC in India, extends a helping hand by offering Instant personal loans for travel in just 5 minutes with PAN, Aadhar and Bank Statement.</p>
 
            <p>Therefore, you need not delay/cancel your travel plans or ask your friends or relatives for financial assistance. With just a few taps/clicks, you can apply for a vacation loan and get paid quickly. Let’s scroll down to learn more about how to apply for a personal loan for travel from CreduMoney.</p>
            <h3>LoanKey Highlights of Getting a Top-Rated  Instant Personal  for Travel from CreduMoney</h3>
            <p>When you choose CreduMoney for a digital loan for travel, you unlock a host of benefits designed to make your journey smooth and stress-free. Let’s look at them one by one.</p>

            <ul>
              <li>Loan Approval and Disbursal in 10 Minutes</li>
              <li>100% Digital Process, right from approval to disbursal</li>
              <li>Paperless Application</li>
              <li>Minimal Documents required</li>
              <li>Collateral-free personal loans</li>
              <li>No Hidden Charges</li>
              <li>Apply from the comfort of your stay</li>
              <li>On-time reminders before the repayment date</li>
            </ul>
            <h3>How to Secure an Instant Personal Loan for Travel from CreduMoney?</h3>
            <p>The process to apply for an online loan for travel from CreduMoney is quick, easy and convenient. Let’s follow the steps mentioned below for the same.</p>
            <ul className="content_list">
              <li>
                Step 1: Visit our website or download the official CreduMoney app from the App/Play Store. Next, register your mobile number as a new user by entering the OPT.
              </li>
              <li>
                Step 2: The next step is to fill out the application form by entering your personal, residential, employment, and income details. Make sure that all the information you have entered is accurate.
              </li>
              <li>
                Step 3: Further, upload the required documents, such as identity proof, address proof, and income proof.
              </li>
              <li>
                Step 4: After you submit your loan application, our team carefully reviews your eligibility by evaluating every detail. If you fit our eligibility criteria, your loan application is instantly approved, and the amount is disbursed directly into your bank account. 
               </li>
              
            </ul>
            <div className="button_container flex justify-center mt30">
              <Link to="/apply-now">Apply Now</Link>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default Travel;
